import { ScreenLoader } from "@/components/ui";
import { useHomeScreenViewModel } from "./HomeScreenViewModel";
import { ModalType } from "./types/ModalTypes";
import { Modals, HomeContainer } from "./components";
import { Helmet } from 'react-helmet-async'

export default function HomeScreen() {
  const viewModel = useHomeScreenViewModel();

  const {
    isLoading,
    isBottomSheetOpen,
    isCenterSheetOpen,
    isVisiblePermissionAlert,
    modalType,
    openBottomSheet,
    closeBottomSheet,
    closeCenterSheet,
    closePermissionAlert,
    openOnDeleteAccountAlert,
    
    // Навигация
    navigateToChat,
    navigateToCardOfTheDay,
    navigateToAstroPrognosis,
    navigateToZodiacPrognosis,
    navigateToLuckyCard,
    navigateToAstrologChanel,
    navigateToDeveloperChanel,
    navigateToSubscription,
    
    logout,
    deleteAccount,
    
    userInfo,
    subscription,
    
    cardOfTheDayStatus,
    astroPrognosisStatus,
    zodiacalPrognosisStatus,
    luckyCardStatus,
    
    isPushNotificationEnabled,
    handleEnableNotifications,
    aboutText,
  } = viewModel;

  const isDataLoading = isLoading || 
    !astroPrognosisStatus || 
    !cardOfTheDayStatus || 
    !zodiacalPrognosisStatus || 
    !luckyCardStatus;

  return (
    <>
      <Helmet>
        <title>Главная страница | Мир Звёзд - Астрологическое приложение</title>
        <meta name="description" content="Добро пожаловать в Мир Звёзд! Ваш персональный астрологический помощник с ежедневными картами Таро, зодиакальными прогнозами и чатом с профессиональным астрологом. Начните свой день с мудрости звезд." />
        <meta name="keywords" content="астрология, гороскоп, карта дня, зодиакальный прогноз, астрологический прогноз, чат с астрологом, таро, астрологическое приложение, мистика, самопознание" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Главная страница | Мир Звёзд - Астрологическое приложение" />
        <meta property="og:description" content="Добро пожаловать в Мир Звёзд! Ваш персональный астрологический помощник с ежедневными картами Таро и зодиакальными прогнозами." />
        <meta property="og:type" content="website" />
      </Helmet>

      <ScreenLoader isLoading={isDataLoading} />
      
      <Modals
        isBottomSheetOpen={isBottomSheetOpen}
        isCenterSheetOpen={isCenterSheetOpen}
        isVisiblePermissionAlert={isVisiblePermissionAlert}
        modalType={modalType}
        closeBottomSheet={closeBottomSheet}
        closeCenterSheet={closeCenterSheet}
        closePermissionAlert={closePermissionAlert}
        openOnDeleteAccountAlert={openOnDeleteAccountAlert}
        deleteAccount={deleteAccount}
        openBottomSheet={openBottomSheet}
        logout={logout}
        userInfo={userInfo}
        subscription={subscription}
        navigateToAstrologChanel={navigateToAstrologChanel}
        navigateToDeveloperChanel={navigateToDeveloperChanel}
        isPushNotificationEnabled={isPushNotificationEnabled}
        handleEnableNotifications={handleEnableNotifications}
        aboutText={aboutText}
        navigateToSubscription={navigateToSubscription}
      />

      <HomeContainer
        navigateToChat={navigateToChat}
        onOpenSettings={() => openBottomSheet(ModalType.Settings)}
        cardOfTheDayStatus={cardOfTheDayStatus}
        astroPrognosisStatus={astroPrognosisStatus}
        zodiacalPrognosisStatus={zodiacalPrognosisStatus}
        luckyCardStatus={luckyCardStatus}
        navigateToCardOfTheDay={navigateToCardOfTheDay}
        navigateToAstroPrognosis={navigateToAstroPrognosis}
        navigateToZodiacPrognosis={navigateToZodiacPrognosis}
        navigateToLuckyCard={navigateToLuckyCard}
      />
    </>
  );
}
